var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-pagination',{staticClass:"cus-page",attrs:{"total":_vm.data.pageTotal,"current":_vm.data.page,"page-size":_vm.data.pageSize,"show-elevator":_vm.showElevator,"show-sizer":_vm.showSizer,"show-total":_vm.showTotal,"transfer":""},on:{"current-change":_vm.pageChange,"size-change":_vm.pageSizeChange}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5f3fcee0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/cuview-ui/components/cus-page/cus-page.vue
// module id = null
// module chunks = 